import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Center,
    Container,
    FormControl,
    Grid,
    Heading,
    Select,
    Text,
    Stack
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux/storage';
import LoadingPage from '../LoadingPage';
import { fetchPaymentData, verifyPayment } from '../../redux/features/paymentSlice';
import MercantilPaymentForm from '../../components/payment/MercantilForm';
import { BankCodes } from '../../utils/const';
import saveForm from '../../redux/actions/bankForms';
import BanescoPaymentForm from '../../components/payment/BanescoForm';
import Alerts from '../../components/ui/Alerts';
import { useNavigate } from 'react-router-dom';
import clearForm from '../../redux/actions/clearForm';
import usePageTitle from '../../utils/pageTitle';


const VerifyPayment = () => {

    const paymentData = useSelector((states: any) => states.paymentForm)
    const paymentResponse = useSelector((states: any) => states.verifyPayment)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()

    usePageTitle("Verificar Pago")

    useEffect(() => {

        dispatch(fetchPaymentData())

        dispatch(clearForm())
    }, [])

    const handleVerifyPaymentForm = (event: any) => {

        event.preventDefault()

        dispatch(verifyPayment(paymentData))
    }

    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        const { name, value } = event.target

        dispatch(saveForm(name, value))

    }

    return (
        <Grid minHeight="100vh">
            <Center>
                <Container>
                    {paymentResponse.loading && <LoadingPage />}
                    {paymentResponse.error !== '' && <Alerts message={paymentResponse.error} title='Error' />}
                    {paymentResponse.response.message !== '' && <Alerts message={paymentResponse.response.message} type={paymentResponse.response.status} title={paymentResponse.response.title} />}
                    {!paymentResponse.loading &&
                        <Card>

                            <Button mt={3} colorScheme="brand" w={150} variant='solid' onClick={() => navigate('/payment/list')}>
                                Listado de pagos
                            </Button>

                            <CardHeader>
                                <Heading size='md'>
                                    <Center>
                                        Verificar pagos
                                    </Center>
                                </Heading>
                            </CardHeader>
                            <CardBody>
                                <Stack spacing={3}>
                                    <form onSubmit={handleVerifyPaymentForm}>
                                        <FormControl>
                                            <Text mb='8px' m={2}>Banco</Text>
                                            <Select name="bank" onChange={handleChange}>
                                                <option value=''>-- Seleccione el banco --</option>
                                                {
                                                    paymentResponse.fetchInitialData.bank.map((banks: any) => {
                                                        if (banks.code === BankCodes.MERCANTIL || banks.code === BankCodes.BANESCO)
                                                            return <option value={banks.code} key={banks.code}>{banks.name}</option>
                                                    }
                                                )
                                                }
                                            </Select>
                                            {paymentData.bank === BankCodes.MERCANTIL && <MercantilPaymentForm />}
                                            {paymentData.bank == BankCodes.BANESCO && <BanescoPaymentForm />}

                                            <Button colorScheme="brand" variant='solid' type='submit' m={2}>Verificar</Button>
                                        </FormControl>
                                    </form>
                                </Stack>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </Center>
        </Grid>
    );
}


export default VerifyPayment;
